import { mixin as clickaway } from 'vue-clickaway'

export default {
    name: 'InputDropdown',
    mixins: [ clickaway ],

    data() {
        return {
            dropdownClass: 'input-dropdown-hidden',
            filterClass: '',
            filterInputClass: '',
            error: '',
            clear: '',
            sortedData: []
        }
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: String,
        data: Array,
        disabled: Boolean
    },

    created() {
        this.sortedData = this.data
    },

    methods: {
        updateValue(value) {
            this.clear = value != '' ? 'input-text-clear' : ''
            this.filter(value)
        },
        
        showItems() {
            this.dropdownClass = ''
            this.filterClass = 'input-dropdown-filter-shown'
            this.filterInputClass = 'input-dropdown-filter-input-shown'
        },

        hideItems() {
            this.dropdownClass = 'input-dropdown-hidden'
            this.filterClass = ''
            this.filterInputClass = ''
            this.doClear()
            this.$refs.inputText.blur()
        },

        selectItem(index) {
            this.$emit('change', this.sortedData[index].id)
            this.doClear()
            this.hideItems()
            this.checkForError()
        },

        checkForError() {
            this.error = this.selectedValue != '' || !this.required ? '' : 'input-dropdown-error'
        },

        doClear() {
            this.clear = ''
            this.$refs.inputText.value = ''
            // this.$refs.inputText.focus()
            this.filter('')
        },

        filter(searchValue) {
            this.sortedData = this.data.filter(item => {
                return item['value'].toLowerCase().includes(searchValue.toLowerCase())
            })
        },
    }
}